'use strict';

var style = require('./style');

module.exports = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/line-height.js
// module id = 240
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818